const location = {
  //项目金主
  path: 'location',
  component: () => import("@/views/home/location/location.vue"),
  meta: {
    // tabBar: 'home'
    tabBar: false
  },
  children:[
    {
      path: 'searchAddress',
      component: () => import("@/views/home/location/searchAddress"),
      meta: {
        tabBar: false
      }
    },
    {
      path: 'selectAddress',
      component: () => import("@/views/home/location/selectAddress"),
      meta: {
        tabBar: false
      }
    },
  ]
};

export default location;
